import { Race } from "../../api/model";
import * as React from "react";
import { TwoColumnsGridData, TwoColumnsGrid } from "../TwoColumnsGrid";
import { RaceTypeLabels, RaceStateLabels } from "../../EnumsLabels";
import { Card, CardMedia } from "@material-ui/core";

export interface RaceDataComponentProps {
    race: Race;
    rutaMapa?: () => string;
}


export default (props: RaceDataComponentProps) => {
    // return <div>{JSON.stringify(props, null, 2)}</div>
    const { race, rutaMapa } = props;
    const colunms: TwoColumnsGridData[] = [];
    

    if (race.owner) {
        colunms.push(
            { type: 'title', label: 'Cliente' },
            { type: 'divider' },
            { label: 'Nombre', value: race.owner.user.name },
            { label: 'Email', value: race.owner.user.email },
            { label: 'Telefono', value: race.owner.phone },
            { label: 'Documento', value: race.owner.document }
        );
    }

    colunms.push(
        { type: 'title', label: RaceTypeLabels[race.type] },
        { type: 'divider' },
        { label: 'Estado', value: RaceStateLabels[race.state] },
        { label: 'Observación', value: race.observation },
        { label: 'Monto', value: race.capital && race.route && race.route.length ? race.capital * (Math.round(race.route.length / 1000)) : 'Sin monto' },
        {
            label: 'Documentos', value: race.tipoComprobante && race.nroComprobante ? 'Tipo de comprobante: ' + race.tipoComprobante + ' ' + race.nroComprobante : race.tipoComprobante && !race.nroComprobante ? race.tipoComprobante+' '+'Sin número de documento' : !race.tipoComprobante && race.nroComprobante ? 'Sin tipo de documento' + ' ' + race.nroComprobante : 'Sin documentos asignados'
        }
    );

    if (race.driver) {
        colunms.push(
            { type: 'title', label: 'Conductor' },
            { type: 'divider' },
            { label: 'Nombre', value: race.driver.user.name }
        );
    }

    colunms.push(
        { type: 'title', label: 'Fechas (control)' },
        { type: 'divider' },
        { label: 'Fecha Inicio', value: race.startDate },
        { label: 'Fecha limite', value: race.dueDate },
        { label: 'Fecha Asignacion', value: race.assignedDate },
        { label: 'Fecha Retiro', value: race.pickDate },
        { label: 'Fecha Entrega', value: race.endDate }
    )

    let ruta;
    if (rutaMapa && rutaMapa() !== "") {
        colunms.push(
            { type: 'title', label: 'Ruta' },
            { type: 'divider' }
        );
        ruta = rutaMapa();
        console.info("Ruta: ", ruta);
    }

    return (
        <div>
            <TwoColumnsGrid data={colunms} />
            {ruta && <Card>
                <CardMedia
                    image={ruta}
                    title="Imagen de la ruta"
                    className="cardMedia"
                    style={{
                        width: 400,
                        height: 400,
                        minHeight: 400,
                        margin: 'auto',
                    }}
                />
            </Card>}
        </div>)
}


// WEBPACK FOOTER //
// ./src/components/race/RaceDataComponent.tsx